import {
  ASSETS_REQUESTS,
  CHECK_ASSETS,
  EMPLOYMENT_STATUS_REQUEST,
  EMPLOYMENT_STATUS_SUCCESS,
  POST_TAXPAYER_EMPLOYMENT_STATUS,
  POST_TAXPAYER_EMPLOYMENT_STATUS_SUCCESS,
  POST_SPOUSE_EMPLOYMENT_STATUS,
  POST_SPOUSE_EMPLOYMENT_STATUS_SUCCESS,
  TAXPAYER_JOBS_REQUEST,
  MARITAL_STATUS_REQUEST_SUCCESS,
  SPOUSE_JOBS_REQUEST,
  EMPLOYMENT_LOADING,
  TAXPAYER_EMPLOYMENT_SUCCESS,
  SPOUSE_EMPLOYMENT_SUCCESS,
  EMPLOYMENT_ERROR,
  POST_NEW_TAXPAYER_JOB,
  POST_NEW_SPOUSE_JOB,
  NEW_TAXPAYER_JOB_SUCCESS,
  NEW_SPOUSE_JOB_SUCCESS,
  DELETE_TAXPAYER_JOB,
  DELETE_TAXPAYER_JOB_SUCCESS,
  DELETE_SPOUSE_JOB,
  DELETE_SPOUSE_JOB_SUCCESS,
  EDIT_TAXPAYER_JOB,
  EDIT_TAXPAYER_JOB_SUCCESS,
  EDIT_SPOUSE_JOB,
  EDIT_SPOUSE_JOB_SUCCESS,
  TAXPAYER_JOB_ITEM_REQUEST,
  TAXPAYER_JOB_ITEM_SUCCESS,
  SPOUSE_JOB_ITEM_REQUEST,
  SPOUSE_JOB_ITEM_SUCCESS,
  REAL_ESTATE_REQUEST,
  REAL_ESTATE_LOADING,
  REAL_ESTATE_SUCCESS,
  REAL_ESTATE_ERROR,
  POST_NEW_REAL_ESTATE,
  NEW_REAL_ESTATE_SUCCESS,
  DELETE_REAL_ESTATE,
  DELETE_REAL_ESTATE_SUCCESS,
  EDIT_REAL_ESTATE,
  EDIT_REAL_ESTATE_SUCCESS,
  REAL_ESTATE_ITEM_REQUEST,
  REAL_ESTATE_ITEM_SUCCESS,
  VEHICLES_REQUEST,
  VEHICLES_LOADING,
  VEHICLES_SUCCESS,
  VEHICLES_ERROR,
  POST_NEW_VEHICLE,
  NEW_VEHICLE_SUCCESS,
  DELETE_VEHICLE,
  DELETE_VEHICLE_SUCCESS,
  EDIT_VEHICLE,
  EDIT_VEHICLE_SUCCESS,
  VEHICLE_ITEM_REQUEST,
  VEHICLE_ITEM_SUCCESS,
  OTHER_ASSETS_REQUEST,
  OTHER_ASSETS_LOADING,
  OTHER_ASSETS_SUCCESS,
  OTHER_ASSETS_ERROR,
  POST_NEW_ASSET,
  NEW_ASSET_SUCCESS,
  DELETE_ASSET,
  DELETE_ASSET_SUCCESS,
  EDIT_ASSET,
  EDIT_ASSET_SUCCESS,
  ASSET_ITEM_REQUEST,
  ASSET_ITEM_SUCCESS,
  HOUSEHOLD_REQUEST,
  HOUSEHOLD_LOADING,
  HOUSEHOLD_SUCCESS,
  HOUSEHOLD_ERROR,
  POST_HOUSEHOLD,
} from '@/app/assets/store/types';
import { LOGOUT, REFRESH_REQUEST } from '@/app/auth/store/types';
import {
  MARITAL_STATUS_REQUEST,
} from '@/app/personal/store/types';

import { http } from '@/api';

export const actions = {
  [CHECK_ASSETS]: ({ getters, dispatch }) => {
    const userId = getters.getUserId;
    dispatch(EMPLOYMENT_STATUS_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(ASSETS_REQUESTS);
      }
    });
    dispatch(TAXPAYER_JOBS_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(ASSETS_REQUESTS);
      }
    });
    dispatch(SPOUSE_JOBS_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(ASSETS_REQUESTS);
      }
    });
    dispatch(REAL_ESTATE_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(ASSETS_REQUESTS);
      }
    });
    dispatch(VEHICLES_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(ASSETS_REQUESTS);
      }
    });
    dispatch(OTHER_ASSETS_REQUEST, userId).catch((err) => {
      if (err.response.status === 401) {
        dispatch(ASSETS_REQUESTS);
      }
    });
  },
  [ASSETS_REQUESTS]: ({ dispatch }, userId) => {
    dispatch(REFRESH_REQUEST)
      .then(() => {
        dispatch(EMPLOYMENT_STATUS_REQUEST, userId);
        dispatch(TAXPAYER_JOBS_REQUEST, userId);
        dispatch(SPOUSE_JOBS_REQUEST, userId);
        dispatch(REAL_ESTATE_REQUEST, userId);
        dispatch(VEHICLES_REQUEST, userId);
        dispatch(OTHER_ASSETS_REQUEST, userId);

        return false;
      });
  },

  /* Employment */
  [EMPLOYMENT_STATUS_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.get(`/assets/apps/${userId}/employment-status`)
      .then((resp) => {
        commit(EMPLOYMENT_STATUS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_TAXPAYER_EMPLOYMENT_STATUS]: ({ commit },
    newItemData) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.put(`/assets/apps/${newItemData.userId}/taxpayer/employment-status?isCurrentlyUnemployed=${newItemData.newItem}`)
      .then((resp) => {
        commit(POST_TAXPAYER_EMPLOYMENT_STATUS_SUCCESS, newItemData.newItem);
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        reject(err);
      });
  })),
  [POST_SPOUSE_EMPLOYMENT_STATUS]: ({ commit },
    newItemData) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.put(`/assets/apps/${newItemData.userId}/spouse/employment-status?isCurrentlyUnemployed=${newItemData.newItem}`)
      .then((resp) => {
        commit(POST_SPOUSE_EMPLOYMENT_STATUS_SUCCESS, newItemData.newItem);
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        reject(err);
      });
  })),
  [TAXPAYER_JOBS_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.get(`/assets/apps/${userId}/taxpayer/employer`)
      .then((resp) => {
        commit(TAXPAYER_EMPLOYMENT_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [SPOUSE_JOBS_REQUEST]: ({ commit, dispatch, getters },
    userId) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    dispatch(MARITAL_STATUS_REQUEST, userId).then((response) => {
      commit(MARITAL_STATUS_REQUEST_SUCCESS, response.data.maritalStatus);
      if (getters.getMaritalStatus !== 1) {
        http.get(`/assets/apps/${userId}/spouse/employer`)
          .then((resp) => {
            commit(SPOUSE_EMPLOYMENT_SUCCESS, resp.data);
            resolve(resp);
          })
          .catch((err) => {
            commit(EMPLOYMENT_ERROR);
            if (err.response.status !== 404) {
              reject(err);
            }
          });
      }
    });
  })),
  [POST_NEW_TAXPAYER_JOB]: ({ commit }, newItem) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.post(`/assets/apps/${newItem.userId}/taxpayer/employer`, newItem.newJob)
      .then((resp) => {
        commit(NEW_TAXPAYER_JOB_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        reject(err);
      });
  })),
  [POST_NEW_SPOUSE_JOB]: ({ commit }, newItem) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.post(`/assets/apps/${newItem.userId}/spouse/employer`, newItem.newJob)
      .then((resp) => {
        commit(NEW_SPOUSE_JOB_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        reject(err);
      });
  })),
  [DELETE_TAXPAYER_JOB]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.delete(`/assets/apps/${item.userId}/taxpayer/employer/${item.id}`)
      .then((resp) => {
        commit(DELETE_TAXPAYER_JOB_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        reject(err);
      });
  })),
  [DELETE_SPOUSE_JOB]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.delete(`/assets/apps/${item.userId}/spouse/employer/${item.id}`)
      .then((resp) => {
        commit(DELETE_SPOUSE_JOB_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        reject(err);
      });
  })),
  [EDIT_TAXPAYER_JOB]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.put(`/assets/apps/${item.userId}/taxpayer/employer/${item.editedItemId}`, item.newJob)
      .then((resp) => {
        commit(EDIT_TAXPAYER_JOB_SUCCESS, item);
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        reject(err);
      });
  })),
  [EDIT_SPOUSE_JOB]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.put(`/assets/apps/${item.userId}/spouse/employer/${item.editedItemId}`, item.newJob)
      .then((resp) => {
        commit(EDIT_SPOUSE_JOB_SUCCESS, item);
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        reject(err);
      });
  })),
  [TAXPAYER_JOB_ITEM_REQUEST]: ({ commit, dispatch }, item) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.get(`/assets/apps/${item.userId}/taxpayer/employer/${item.itemId}`)
      .then((resp) => {
        commit(TAXPAYER_JOB_ITEM_SUCCESS, {
          item: resp.data,
          id: item.itemId,
        });
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(LOGOUT);
          } else {
            reject(err);
          }
        }
      });
  })),
  [SPOUSE_JOB_ITEM_REQUEST]: ({ commit, dispatch }, item) => new Promise(((resolve, reject) => {
    commit(EMPLOYMENT_LOADING);
    http.get(`/assets/apps/${item.userId}/spouse/employer/${item.itemId}`)
      .then((resp) => {
        commit(SPOUSE_JOB_ITEM_SUCCESS, {
          item: resp.data,
          id: item.itemId,
        });
        resolve(resp);
      })
      .catch((err) => {
        commit(EMPLOYMENT_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(LOGOUT);
          } else {
            reject(err);
          }
        }
      });
  })),

  /* Real Estate */
  [REAL_ESTATE_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(REAL_ESTATE_LOADING);
    http.get(`/assets/apps/${userId}/real-estate`)
      .then((resp) => {
        commit(REAL_ESTATE_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(REAL_ESTATE_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_NEW_REAL_ESTATE]: ({ commit }, newItemData) => new Promise(((resolve, reject) => {
    commit(REAL_ESTATE_LOADING);
    http.post(`/assets/apps/${newItemData.userId}/real-estate`, newItemData.newItem)
      .then((resp) => {
        commit(NEW_REAL_ESTATE_SUCCESS, {
          ...resp,
          county: newItemData.newItem.countyName,
        });
        resolve(resp);
      })
      .catch((err) => {
        commit(REAL_ESTATE_ERROR);
        reject(err);
      });
  })),
  [DELETE_REAL_ESTATE]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(REAL_ESTATE_LOADING);
    http.delete(`/assets/apps/${item.userId}/real-estate/${item.id}`)
      .then((resp) => {
        commit(DELETE_REAL_ESTATE_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(REAL_ESTATE_ERROR);
        reject(err);
      });
  })),
  [EDIT_REAL_ESTATE]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(REAL_ESTATE_LOADING);
    http.put(`/assets/apps/${item.userId}/real-estate/${item.editedItemId}`, item.newItem)
      .then((resp) => {
        commit(EDIT_REAL_ESTATE_SUCCESS, item);
        resolve(resp);
      })
      .catch((err) => {
        commit(REAL_ESTATE_ERROR);
        reject(err);
      });
  })),
  [REAL_ESTATE_ITEM_REQUEST]: ({ commit, dispatch }, item) => new Promise(((resolve, reject) => {
    commit(REAL_ESTATE_LOADING);
    http.get(`/assets/apps/${item.userId}/real-estate/${item.itemId}`)
      .then((resp) => {
        commit(REAL_ESTATE_ITEM_SUCCESS, {
          item: resp.data,
          id: item.itemId,
        });
        resolve(resp);
      })
      .catch((err) => {
        commit(REAL_ESTATE_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(LOGOUT);
          } else {
            reject(err);
          }
        }
      });
  })),

  /* Vehicles */
  [VEHICLES_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(VEHICLES_LOADING);
    http.get(`/assets/apps/${userId}/vehicle`)
      .then((resp) => {
        commit(VEHICLES_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(VEHICLES_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_NEW_VEHICLE]: ({ commit }, newItemData) => new Promise(((resolve, reject) => {
    commit(VEHICLES_LOADING);
    http.post(`/assets/apps/${newItemData.userId}/vehicle`, newItemData.newItem)
      .then((resp) => {
        commit(NEW_VEHICLE_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        commit(VEHICLES_ERROR);
        reject(err);
      });
  })),
  [DELETE_VEHICLE]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(VEHICLES_LOADING);
    http.delete(`/assets/apps/${item.userId}/vehicle/${item.id}`)
      .then((resp) => {
        commit(DELETE_VEHICLE_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(VEHICLES_ERROR);
        reject(err);
      });
  })),
  [EDIT_VEHICLE]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(VEHICLES_LOADING);
    http.put(`/assets/apps/${item.userId}/vehicle/${item.editedItemId}`, item.newItem)
      .then((resp) => {
        commit(EDIT_VEHICLE_SUCCESS, item);
        resolve(resp);
      })
      .catch((err) => {
        commit(VEHICLES_ERROR);
        reject(err);
      });
  })),
  [VEHICLE_ITEM_REQUEST]: ({ commit, dispatch }, item) => new Promise(((resolve, reject) => {
    commit(VEHICLES_LOADING);
    http.get(`/assets/apps/${item.userId}/vehicle/${item.itemId}`)
      .then((resp) => {
        commit(VEHICLE_ITEM_SUCCESS, {
          item: resp.data,
          id: item.itemId,
        });
        resolve(resp);
      })
      .catch((err) => {
        commit(VEHICLES_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(LOGOUT);
          } else {
            reject(err);
          }
        }
      });
  })),

  /* Other Assets */
  [OTHER_ASSETS_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(OTHER_ASSETS_LOADING);
    http.get(`/assets/apps/${userId}/other-asset`)
      .then((resp) => {
        commit(OTHER_ASSETS_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(OTHER_ASSETS_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_NEW_ASSET]: ({ commit }, newItemData) => new Promise(((resolve, reject) => {
    commit(OTHER_ASSETS_LOADING);
    http.post(`/assets/apps/${newItemData.userId}/other-asset`, newItemData.newItem)
      .then((resp) => {
        commit(NEW_ASSET_SUCCESS, resp);
        resolve(resp);
      })
      .catch((err) => {
        commit(OTHER_ASSETS_ERROR);
        reject(err);
      });
  })),
  [DELETE_ASSET]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(OTHER_ASSETS_LOADING);
    http.delete(`/assets/apps/${item.userId}/other-asset/${item.id}`)
      .then((resp) => {
        commit(DELETE_ASSET_SUCCESS, item.id);
        resolve(resp);
      })
      .catch((err) => {
        commit(OTHER_ASSETS_ERROR);
        reject(err);
      });
  })),
  [EDIT_ASSET]: ({ commit }, item) => new Promise(((resolve, reject) => {
    commit(OTHER_ASSETS_LOADING);
    http.put(`/assets/apps/${item.userId}/other-asset/${item.editedItemId}`, item.newItem)
      .then((resp) => {
        commit(EDIT_ASSET_SUCCESS, item);
        resolve(resp);
      })
      .catch((err) => {
        commit(OTHER_ASSETS_ERROR);
        reject(err);
      });
  })),
  [ASSET_ITEM_REQUEST]: ({ commit, dispatch }, item) => new Promise(((resolve, reject) => {
    commit(OTHER_ASSETS_LOADING);
    http.get(`/assets/apps/${item.userId}/other-asset/${item.itemId}`)
      .then((resp) => {
        commit(ASSET_ITEM_SUCCESS, {
          item: resp.data,
          id: item.itemId,
        });
        resolve(resp);
      })
      .catch((err) => {
        commit(OTHER_ASSETS_ERROR);
        if (err.response.status !== 404) {
          if (err.response.status === 401) {
            dispatch(LOGOUT);
          } else {
            reject(err);
          }
        }
      });
  })),

  /* Household */
  [HOUSEHOLD_REQUEST]: ({ commit }, userId) => new Promise(((resolve, reject) => {
    commit(HOUSEHOLD_LOADING);
    http.get(`/assets/apps/${userId}/household-income`)
      .then((resp) => {
        commit(HOUSEHOLD_SUCCESS, resp.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(HOUSEHOLD_ERROR);
        if (err.response.status !== 404) {
          reject(err);
        }
      });
  })),
  [POST_HOUSEHOLD]: ({ commit }, newItemData) => new Promise(((resolve, reject) => {
    commit(HOUSEHOLD_LOADING);
    http.put(`/assets/apps/${newItemData.userId}/household-income`, newItemData.newItem)
      .then((resp) => {
        commit(HOUSEHOLD_SUCCESS, resp.config.data);
        resolve(resp);
      })
      .catch((err) => {
        commit(HOUSEHOLD_ERROR);
        reject(err);
      });
  })),
};
